<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card class="i-empty-card rounded-0 pa-4 pa-md-6 mt-2 mt-md-4">
        <h3>{{ title }}</h3>
        <br />
        <v-btn
          rounded
          class="i-empty-card-btn"
          raised
          large
          :to="{ name: buttonRouteName }"
          v-if="!hideButton"
        >
          <strong>{{ buttonText }}</strong>
        </v-btn>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    title: {
      default: 'No results found',
      type: String
    },
    buttonText: {
      default: 'Dashboard',
      type: String
    },
    buttonRouteName: {
      default: 'dashboard',
      type: String
    },
    hideButton: {
      default: false,
      type: Boolean
    }
  }
}
</script>
